import React, { useEffect, useState } from "react";
import { getCompanies, deleteCompany } from "../../services/companyService";
import { Link } from "react-router-dom";
import { FaEdit, FaTrash } from "react-icons/fa";
import Layout from "../../components/layout/Layout";

function CompanyList() {

  const [companies, setCompanies] = useState([]);
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);

  const [deleteId, setDeleteId] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showToast, setShowToast] = useState(false);

  const itemsPerPage = 5;

  const fetchCompanies = async () => {
    const res = await getCompanies();
    setCompanies(res.data);
  };

  useEffect(() => {
    fetchCompanies();
  }, []);

  // SEARCH
  const filteredCompanies = companies.filter((c) =>
    c.companyName.toLowerCase().includes(search.toLowerCase())
  );

  // PAGINATION
  const indexOfLast = currentPage * itemsPerPage;
  const indexOfFirst = indexOfLast - itemsPerPage;
  const currentCompanies = filteredCompanies.slice(indexOfFirst, indexOfLast);

  const totalPages = Math.ceil(filteredCompanies.length / itemsPerPage);

  const openDeleteModal = (id) => {
    setDeleteId(id);
    setShowModal(true);
  };

  const handleDelete = async () => {
    await deleteCompany(deleteId);
    setShowModal(false);
    setShowToast(true);
    fetchCompanies();

    setTimeout(() => {
      setShowToast(false);
    }, 3000);
  };

  return (

    <Layout>

      <div className="container-fluid mt-4">

        {/* HEADER */}

        <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-3">

          <h3 className="mb-2 mb-md-0">Company List</h3>

          <Link to="/admin/add-company" className="btn btn-primary">
            + Add Company
          </Link>

        </div>

        {/* SEARCH */}

        <div className="mb-3">

          <input
            type="text"
            className="form-control"
            placeholder="Search company..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />

        </div>

        {/* ================= DESKTOP TABLE ================= */}

        <div className="table-responsive d-none d-md-block">

          <table className="table table-bordered table-hover">

            <thead className="table-dark">

              <tr>
                <th>Name</th>
                <th>Code</th>
                <th>Level</th>
                <th>Relation</th>
                <th className="text-center">Action</th>
              </tr>

            </thead>

            <tbody>

              {currentCompanies.map((c) => (

                <tr key={c._id}>

                  <td>{c.companyName}</td>
                  <td>{c.companyCode}</td>
                  <td>{c.hierarchicalLevel}</td>
                  <td>{c.relationType}</td>

                  <td className="text-center">

                    <Link
                      to={`/admin/edit-company/${c._id}`}
                      className="btn btn-success btn-sm me-2"
                    >
                      <FaEdit />
                    </Link>

                    <button
                      className="btn btn-danger btn-sm"
                      onClick={() => openDeleteModal(c._id)}
                    >
                      <FaTrash />
                    </button>

                  </td>

                </tr>

              ))}

            </tbody>

          </table>

        </div>

        {/* ================= MOBILE CARD VIEW ================= */}

        <div className="d-md-none">

          {currentCompanies.map((c) => (

            <div key={c._id} className="card shadow-sm mb-3">

              <div className="card-body">

                <h5 className="card-title">{c.companyName}</h5>

                <p className="mb-1">
                  <strong>Code:</strong> {c.companyCode}
                </p>

                <p className="mb-1">
                  <strong>Level:</strong> {c.hierarchicalLevel}
                </p>

                <p className="mb-2">
                  <strong>Relation:</strong> {c.relationType}
                </p>

                <div className="d-flex gap-2">

                  <Link
                    to={`/admin/edit-company/${c._id}`}
                    className="btn btn-success btn-sm"
                  >
                    <FaEdit />
                  </Link>

                  <button
                    className="btn btn-danger btn-sm"
                    onClick={() => openDeleteModal(c._id)}
                  >
                    <FaTrash />
                  </button>

                </div>

              </div>

            </div>

          ))}

        </div>

        {/* PAGINATION */}

        <div className="d-flex justify-content-center">

          <ul className="pagination">

            {[...Array(totalPages)].map((_, i) => (

              <li
                key={i}
                className={`page-item ${currentPage === i + 1 ? "active" : ""}`}
              >

                <button
                  className="page-link"
                  onClick={() => setCurrentPage(i + 1)}
                >
                  {i + 1}
                </button>

              </li>

            ))}

          </ul>

        </div>

      </div>

      {/* DELETE MODAL */}

      {showModal && (

        <div className="modal fade show d-block">

          <div className="modal-dialog">

            <div className="modal-content">

              <div className="modal-header">

                <h5 className="modal-title">Delete Company</h5>

                <button
                  className="btn-close"
                  onClick={() => setShowModal(false)}
                ></button>

              </div>

              <div className="modal-body">

                Are you sure you want to delete this company?

              </div>

              <div className="modal-footer">

                <button
                  className="btn btn-secondary"
                  onClick={() => setShowModal(false)}
                >
                  Cancel
                </button>

                <button
                  className="btn btn-danger"
                  onClick={handleDelete}
                >
                  Delete
                </button>

              </div>

            </div>

          </div>

        </div>

      )}

      {/* TOAST */}

      {showToast && (

        <div
          className="position-fixed top-0 end-0 p-3"
          style={{ zIndex: 9999 }}
        >

          <div className="toast show text-bg-success">

            <div className="d-flex">

              <div className="toast-body">
                Company deleted successfully
              </div>

              <button
                className="btn-close btn-close-white me-2 m-auto"
                onClick={() => setShowToast(false)}
              ></button>

            </div>

          </div>

        </div>

      )}

    </Layout>

  );

}

export default CompanyList;